import { useQuery } from '@tanstack/react-query';

import { dealQueryOptions } from './query-options';

import type { TInWorkOrFinishedDealsQueryParams } from '../model/in-work-or-finished-deals';

export const useGetInWorkOrFinishedDealsQuery = (
    queryParams: TInWorkOrFinishedDealsQueryParams,
    { enabled = true }: { enabled?: boolean } = {},
) =>
    useQuery({
        ...dealQueryOptions.getInWorkOrFinishedDealsQueryOptions(queryParams),
        enabled,
    });
